/**
 * isLogin 是否登录
 * token  验证是否登录凭证
 */
const state = {
  webSocketMsg: '',
  webSocketConnect: false,
  isLogin: false,
  token: '',
  detailsID: ''
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js